import React, { useState, useEffect } from 'react'
import Input from 'components/Input'
import 'react-input-range/lib/css/index.css'
import styles from './Range.scss'
import _ from 'lodash'

const options = ['Pick', 'Greater than', 'Equal to', 'Less than', 'Between']
const [PICK, MORE, EXACT, FEWER, BETWEEN] = options
const MIN = 'min'
const MAX = 'max'
const EQUAL = 'exact'

type RangeValue = 
  | number
  | {
      min?: number
      max?: number
      picker?: string
      exact?: number
    }

interface RangeProps {
  onChange: (value: RangeValue) => void
  value?: RangeValue
}

export default function Range({ value: activeValue, onChange }: RangeProps) {
  const [value, setValue] = useState<{ picker: string; min?: number; max?: number; exact?: number }>({ picker: PICK })

  const resetValues = () => setValue({ picker: PICK })

  useEffect(() => {
    if (activeValue && !_.isEqual(activeValue, {})) {
      setValue(activeValue as { picker: string; min?: number; max?: number; exact?: number })
      return
    }

    resetValues()
  }, [activeValue])

  const onManualChange = (type: string, nextValue: number | undefined) => {
    if (nextValue !== 0 && !nextValue) {
      resetValues()
      return
    }

    const manualValue = {
      ...value,
      [type]: nextValue,
    }

    setValue(manualValue)
  }

  const onBlur = () => onChange(value)

  return (
    <div className={styles.container}>
      <Input
        type='select'
        value={value.picker}
        onChange={(picker: string) => {
          setValue({ picker })
          if (picker === PICK) {
            onChange({ picker })
          }
        }}
      >
        {options.map((option, index) => (
          <option key={index}>{option}</option>
        ))}
      </Input>
      {value.picker === FEWER && (
        <div className={styles.inputs}>
          <Input
            type='number'
            value={value[MAX]}
            onChange={(nextValue: number) => onManualChange(MAX, nextValue)}
            onBlur={onBlur}
            className={styles.input}
          />
        </div>
      )}
      {value.picker === MORE && (
        <div className={styles.inputs}>
          <Input
            type='number'
            value={value[MIN]}
            onChange={(nextValue: number) => onManualChange(MIN, nextValue)}
            onBlur={onBlur}
            className={styles.input}
          />
        </div>
      )}
      {value.picker === EXACT && (
        <div className={styles.inputs}>
          <Input
            type='number'
            value={value[EQUAL]}
            onChange={(nextValue: number) => onManualChange(EQUAL, nextValue)}
            onBlur={onBlur}
            className={styles.input}
          />
        </div>
      )}
      {value.picker === BETWEEN && (
        <div className={styles.inputs}>
          <Input
            type='number'
            value={value[MIN]}
            hint='min'
            onChange={(nextValue: number) => onManualChange(MIN, nextValue)}
            onBlur={onBlur}
            className={styles.input}
          />
          <span className={styles.separator}>-</span>
          <Input
            type='number'
            hint='max'
            value={value[MAX]}
            onChange={(nextValue: number) => onManualChange(MAX, nextValue)}
            onBlur={onBlur}
            className={styles.input}
          />
        </div>
      )}
    </div>
  )
}

